import translateMessages from '../locale/translateMessages'

const errorsParsing = {
  methods: {
    errorsParsing (responseErrors) {
      for (const [key, errors] of Object.entries(responseErrors)) {
        errors.forEach(error => {
          this.$validator.errors.add({
            field: key,
            msg: translateMessages(error)
          })
        })
      }
    }
  }
}

export default errorsParsing
